__webpack_require__.p = "/investigations/pandora-papers/charts/";